import { apiClient } from "./httpClient";
import { unwrapEnvelope, unwrapMeta } from "./response";

export const adminApi = {
  async listTenants(params = {}) {
    const response = await apiClient.get("/admin/tenants", { params });
    return {
      data: unwrapEnvelope(response.data, []),
      meta: unwrapMeta(response.data, {})
    };
  },

  async getTenant(id) {
    const response = await apiClient.get(`/admin/tenants/${id}`);
    return unwrapEnvelope(response.data, {});
  },

  async extendTrial(id, payload) {
    const response = await apiClient.post(`/admin/tenants/${id}/extend-trial`, payload);
    return unwrapEnvelope(response.data, {});
  },

  async activateTenant(id) {
    const response = await apiClient.post(`/admin/tenants/${id}/activate`);
    return unwrapEnvelope(response.data, {});
  },

  async changeTenantPlan(id, payload) {
    const response = await apiClient.post(`/admin/tenants/${id}/change-plan`, payload);
    return unwrapEnvelope(response.data, {});
  },

  async suspendTenant(id) {
    const response = await apiClient.post(`/admin/tenants/${id}/suspend`);
    return unwrapEnvelope(response.data, {});
  },

  async reactivateTenant(id) {
    const response = await apiClient.post(`/admin/tenants/${id}/reactivate`);
    return unwrapEnvelope(response.data, {});
  },

  async getAnalytics() {
    const response = await apiClient.get("/admin/analytics");
    return unwrapEnvelope(response.data, {});
  },

  async getSubscriptions() {
    const response = await apiClient.get("/admin/subscriptions");
    return unwrapEnvelope(response.data, {});
  },

  async impersonate(userId) {
    const response = await apiClient.post("/admin/impersonate", { user_id: userId });
    return unwrapEnvelope(response.data, {});
  },

  async exitImpersonation() {
    const response = await apiClient.post("/admin/impersonate/exit");
    return unwrapEnvelope(response.data, {});
  }
};
